<template>
  <transition-group
      name="list"
      mode="out-in"
      tag="div"
      class="w-100 p-b-6">
    <div class="p-y-2" key="whats-new-items">
      <div>
        <whats-new-sub-section
            :open-image-modal="openImageModal"
            :sub-section="latestSection"/>
      </div>
      <div
          v-for="(month, index) in monthSections"
          :key="index"
      >
        <whats-new-sub-section
            :open-image-modal="openImageModal"
            :sub-section="month"/>
      </div>
    </div>
  </transition-group>
</template>

<script>
import Storage from '@homeservices/tool-kit/storage/local-storage';
import WhatsNewSubSection from './WhatsNewSubSection';
import JobItemGhost from './JobItemGhost';

const UPDATES_LAST_SEEN_TIME = 'TIME_LAST_SEEN';
export default {
  name: 'whats-new-list',

  components: {
    JobItemGhost,
    WhatsNewSubSection,
  },
  props: {
    openImageModal: {
      type: Function,
    },
    groupedWhatsNew: {
      type: Object,
      default () { return {}; },
    },
  },
  computed: {
    sections () {
      return Object.entries(this.groupedWhatsNew).map((entry) => {
        const [key, value] = entry;
        return {
          title: key,
          articles: value,
        };
      });
    },
    latestSection () {
      return this.sections.filter(item => item.title === 'latest')[0];
    },
    monthSections () {
      return this.sections.filter(item => item.title !== 'latest');
    },
  },
  mounted () {
    Storage.set(UPDATES_LAST_SEEN_TIME, { time: new Date() });
  },
};
</script>
